/*  AU-no-newsletter  */
/**/
/* ContactLab lib config and import are placed in "theme.liquid" */
/**/

(function (window) {
  var $footerForm;
  var $popup;
  var $popupForm;
  var $input;
  var $select;
  var $dobSelectGroup;
  var $submit;
  var storeMarket = $("html").attr("data-market");
  const NEWSLETTER_POPUP_COOKIE = "newsletter-popup-" + storeMarket;

  $(document).ready(function () {
    $footerForm = $("#newsletter-footer .Footer__Newsletter.Form");
    $popup = $("#newsletter-popup");
    $popupForm = $popup.find("form");
    $dobSelectGroup = $("#Footer__Newsletter-birtday-selects");

    $footerForm
      .find('input.Form__Input[name="email"]')
      .one("focus", function (event) {
        $footerForm.parent().addClass("expanded");
      });

    $dobSelectGroup.find("select").on("change", function () {
      var day = $dobSelectGroup.find("select:nth-of-type(1)").val();
      var month = $dobSelectGroup.find("select:nth-of-type(2)").val();
      var year = $dobSelectGroup.find("select:nth-of-type(3)").val();

      if (day != "" && month != "" && year != "") {
        $footerForm
          .find('input[name="dob"]')
          .val(year + "-" + month + "-" + day);
      } else {
        $footerForm.find('input[name="dob"]').val("");
      }
    });

    // handle success message for AU market (Shopify submit)
    if ($("html").attr("data-market") === "au" && new URLSearchParams(window.location.search).has('customer_posted') && new URLSearchParams(window.location.search).get('customer_posted') == "true") {
        window.scrollTo(0, $footerForm.offset().top);
        handleSuccess("footer");
    }

    // popup is enabled only for non AU markets
    if ($("html").attr("data-market") === "au"){
        // removePopup();
        // $popupForm.on("submit", function (event) {
        //     event.preventDefault();
        //     event.stopPropagation();
        //     event.stopImmediatePropagation();
        // });
    }
    else {
        if (!window.getCookie(NEWSLETTER_POPUP_COOKIE)) {
          window.setCookie(NEWSLETTER_POPUP_COOKIE, "1");
        } else if (window.getCookie(NEWSLETTER_POPUP_COOKIE) == "1") {
          window.setCookie(NEWSLETTER_POPUP_COOKIE, "2");
        } else if (window.getCookie(NEWSLETTER_POPUP_COOKIE) == "2") {
          window.setCookie(NEWSLETTER_POPUP_COOKIE, "3");
        } else if (window.getCookie(NEWSLETTER_POPUP_COOKIE) === "3") {
          $popupForm.on("submit", function (event) {
            if ($("html").attr("data-market") !== "au") {
              event.preventDefault();
              event.stopPropagation();
              event.stopImmediatePropagation();

              submitToContactLab(event, "popup");
            }
          });

          $popup.find("#newsletter-popup_close-btn").one("click", function (event) {
            $popupForm.off().remove();
            $popupForm = null;

            $popup.off().remove();
            $popup = null;

            window.setCookie(NEWSLETTER_POPUP_COOKIE, "closed");
          });

          $popup
            .css({
              opacity: 0,
              display: "block",
            })
            .animate(
              {
                opacity: 1,
              },
              850
            );
        } else {
          removePopup();
        }
    }

    $footerForm.on("submit", function (event) {
      if ($("html").attr("data-market") !== "au") {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        submitToContactLab(event, "footer");
      }
    });
  });

  function removePopup() {
      $popupForm.remove();
      $popupForm = null;
      $popup.remove();
      $popup = null;
  }

  function submitToContactLab(event, ref) {
    var data = {
      shop_code: storeMarket.toUpperCase(),
      email: $(event.delegateTarget).find('[name="email"]').val(),
      language: $(event.delegateTarget).find('[name="spoken_language"]').val(),
    };

    if (ref === "footer") {
      data.firstName = $(event.delegateTarget)
        .find('[name="first-name"]')
        .val();
      data.lastName = $(event.delegateTarget).find('[name="last-name"]').val();
      data.dob = $(event.delegateTarget).find('input[name="dob"]').val();
      data.getInTouch = $(event.delegateTarget)
        .find('[name="get-in-touch"]')
        .val();
      data.gender = $(event.delegateTarget)
      .find('[name="gender"]')
      .val();

      data.interests = [];
      $(event.delegateTarget).find('input[name="interest[]"]:checked').each(function(i){
        data.interests.push($(this).val());
      });
    }

    // PRIVACY HANDLER - unnecessary!
    /* data.generic = $(event.delegateTarget)
    .find('[name="generic_privacy"]')
    .is(":checked"); */

    data.marketing = $(event.delegateTarget)
    .find('[name="marketing"]') && $(event.delegateTarget)
    .find('[name="marketing"]')
    .is(":checked");

    data.profiling = $(event.delegateTarget)
    .find('[name="profiling"]') && $(event.delegateTarget)
    .find('[name="profiling"]')
    .is(":checked");

    var fields = getFields(ref);

    fields.$input.attr("disabled", "disabled");
    if (fields.$select) fields.$select.attr("disabled", "disabled");
    fields.$submit.attr("disabled", "disabled");

    var chCustomerParams = {
      externalId: data.email,
      base: {
        contacts: {
          email: data.email,
        },
        subscriptions: [
          {
            id: "NL_SHOPIFY",
            name: "NL_SHOPIFY",
            subscribed: true,
            kind: "DIGITAL_MESSAGE",
          },
        ],
      },
      extended: {
        customer_info: {
          shop_code: data.shop_code,
          language: data.language,
          is_from_shopify: "true",
        },
      },
      consents: {
        marketing: {
            automatic: {
                email: {
                    status: false
                }
            }
        },
        profiling: {
            online: {
                status: false
            }
        }
    }
    };

    if (data.firstName && data.firstName != "")
      chCustomerParams.base.firstName = data.firstName;
    if (data.lastName && data.lastName != "")
      chCustomerParams.base.lastName = data.lastName;
    if (data.dob && data.dob != "") chCustomerParams.base.dob = data.dob;
    // if (data.getInTouch && data.getInTouch != "") {
    //   chCustomerParams.extended.customer_info.know_us = '';
    // }
    chCustomerParams.extended.customer_info.know_us = '';
    if (data.interests && data.interests != "" && data.interests.length > 0) {
      chCustomerParams.extended.customer_info.interests = data.interests.join(',');
    } else {
      chCustomerParams.extended.customer_info.interests = '';
    }
    if (data.gender && data.gender != "") {
      chCustomerParams.base.gender = data.gender;
    }

    /* unnecessary!
     chCustomerParams['Accepts Privacy'] = data.generic; */
    chCustomerParams.consents.marketing.automatic.email.status = data.marketing;
    chCustomerParams.consents.profiling.online.status = data.profiling;
      // chCustomerParams.extended.customer_info.know_us = data.getInTouch;


    // console.log('chCustomerParams', chCustomerParams);
    //Submit to ContactLab via SDK
    ch("customer", chCustomerParams);

    //Dispatch "formCompiled" event via SDK
    ch("event", {
      type: "formCompiled",
      context: "ECOMMERCE",
      date: new Date().toISOString(),
      bringBackProperties: {
        type: "EXTERNAL_ID",
        value: data.email,
        nodeId: "9d759975-7e90-4113-a858-9e76a93569e1", //PROD
        // nodeId: "0a812514-af45-4995-97a3-245a0190717b", //STAGING
      },
      properties: {
        formName: "Welcome",
      },
    });

    //the ContactLab SDK doesn't provide a callback method
    handleSuccess(ref);
  }

  function handleSuccess(ref) {
    var fields = getFields(ref);
    var successText = fields.$form.parent().attr("data-success-text");
    var successTemplate = `<div class="success-overlay" style="z-index: 2; position: absolute; top: 0; right:0; bottom:0; left: 0; display: flex; justify-content:center; align-items: center; text-align: center; padding: 12px; background: #eee; text-transform: uppercase;">${successText}</div>`;

    fields.$form.css({
      position: "relative",
      top: 0,
      left: 0,
    });
    fields.$form.append(successTemplate);

    setTimeout(resetFormNewsletterFields, 5000, ref);
  }

  function resetFormNewsletterFields(ref) {
    var fields = getFields(ref);
    fields.$input.val("").removeAttr("disabled");
    if (ref === "footer") {
      fields.$select.prop("selectedIndex", 0).removeAttr("disabled");
      fields.$checkbox.prop( "checked", false );
    }
    fields.$submit.removeAttr("disabled");
    fields.$form.find(".success-overlay").remove();
  }

  function getFields(ref) {
    var $form;
    var $input;
    var $select;
    var $submit;

    switch (ref) {
      case "footer":
        $form = $footerForm;
        $select = $footerForm.find("select");
        $checkbox = $footerForm.find("input.custom-cb");
        $input = $footerForm.find("input.Form__Input");
        $submit = $footerForm.find('button[type="submit"]');
        break;

      case "popup":
        $form = $popupForm;
        $checkbox = $popupForm.find("input.custom-cb");
        $input = $popupForm.find("input.Form__Input");
        $submit = $popupForm.find('button[type="submit"]');
        break;
    }

    return {
      $form: $form,
      $input: $input,
      $select: $select,
      $checkbox: $checkbox,
      $submit: $submit,
    };
  }
})(window);
